import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import EnvioFacturasDetalles from './EnvioGuiasDetalles'
import { Form } from '../../../components/form/DynamicFormTs'
import { TextField, InputAdornment, Button } from '@material-ui/core';
import Http from '../../../Http';
import { withRouter } from 'react-router-dom'

class EnvioFacturas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'guia/one', saveUrl: 'guia/save', backUrl: '/' },
      new Form([
        Form.Field('text', 'linea', 'Linea', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'g_folio', 'Guia', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'origen', 'Origen', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'destino', 'Destino', '', [], 6, [], [], [], false, true),
        Form.Field('date', 'g_fecha', 'Fecha', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'cliente', 'Cliente', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'cliente_rsocial', 'Cliente Razon Social', '', [], 6, [], [], [], false, true),
        Form.Field('date', 'g_fecha', 'Fecha', '', [], 6, [], [], [], false, true),
        Form.Section('Papeleria Obligatoria'),
        Form.Field('checkbox', 'cliente_pape_factura', 'Factura?', '', [], 6, [], [], [], false, true),
        Form.Field('checkbox', 'cliente_pape_remision', 'Remision?', '', [], 6, [], [], [], false, true),
        Form.Field('checkbox', 'cliente_pape_salida', 'Orden Salida?', '', [], 6, [], [], [], false, true),
        Form.Field('checkbox', 'cliente_pape_tarima', 'Vale Tarima?', '', [], 6, [], [], [], false, true),
      ], [], ''), this.formData
    );
    let id = this.props.match.params.id;
    if (id) {
      this.LoadPreds(id);
    } else {
      this.setState({ id, ready: true })
    }
  }

  LoadPreds = async (id) => {
    const Resp = await Http.get(`facturacion/one/${id}`);
    if (!Resp.error) {

      this.setState({ id, ready: true, currentEnvio: Resp.data })
    }
  }

  formData = async () => {
    let Res = await Http.get(`guia/detalle-form`);
    if (!Res.error) {
      const tiposCobro = Res.data.tiposDeCobro;
      this.setState({ tiposCobro });
    }
  }

  showGuia = async (id_guia) => {
    const Res = await Http.get(`guia/info/${id_guia}`);
    if (!Res.error) {
      const { FormData } = this.state;
      let guia = Res.data;
      let newFormData = Form.Patch(FormData, { ...Res.data, ...Res.data.cliente });
      for (const tipo of Res.data.cobrosAplicados) {
        guia[`tipo_${tipo.id_lista_precio_tipo}`] = tipo.valor_aplicado;
      }
      this.setState({ FormData: newFormData, guia })
    }
  }

  downloadReport = async () => {
    const { id } = this.props.match.params;
    this.setState({ loadingReport: true });
    const Resp = await Http.get(`facturacion/reporte-factura/excel?factura_id=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_envios_cyc_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loadingReport: false });
  };

  downloadPagoTransportistas = async () => {
    this.setState({ loadingPago: true });
    const { id } = this.props.match.params;
    const Resp = await Http.get(`transportista/pago-transportista-pdf?id_folio_cyc=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/pdf' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `pago__entrega_cyc_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loadingPago: false });
  };

  downloadPagoTransportistasExcel = async () => {
    this.setState({ loadingPagoExcel: true });
    const { id } = this.props.match.params;
    const Resp = await Http.get(`transportista/pago-entrega-cyc?id_folio_cyc=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `pago_entrega_cyc_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo excel' });
    }
    this.setState({ loadingPagoExcel: false });
  };


  render() {
    let { tiposCobro, guia, id, ready, currentEnvio, loadingPago = false, loadingPagoExcel = false, loadingReport = false } = this.state;
    tiposCobro = tiposCobro || [];
    guia = guia || {};
    return (
      <div className='row'>
        <div className="col-sm-6">
          <div >
            <h1>{id ? `Folio de envio #${id}` : 'Nuevo Folio'}</h1>
            {
              id && (
                <Button
                  onClick={this.downloadReport}
                  color="primary"
                  variant="contained"
                  style={{ marginRight: 5 }}
                  disabled={loadingReport}
                >
                  Descargar Reporte
                </Button>
              )
            }
            <Button
              onClick={this.downloadPagoTransportistas}
              color="primary"
              variant="contained"
              style={{ marginRight: 5 }}
              disabled={loadingPago}
            >
              Descargar Pago Transportista
            </Button>
            <Button
              onClick={this.downloadPagoTransportistasExcel}
              color="primary"
              variant="contained"
              style={{ marginRight: 5 }}
              disabled={loadingPagoExcel}
            >
              Descargar Excel
            </Button>
          </div>
          <div className="row">
            <this.FormRender />
          </div>
          <div className="row" >
            {tiposCobro.map(tipoCobro => (
              <div key={tipoCobro.id} className="col-12 col-sm-6">
                <TextField
                  readOnly
                  type="number"
                  value={guia[`tipo_${tipoCobro.id}`] || "0"}
                  label={tipoCobro.lpt_nombre}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    )
                  }}
                />
              </div>
            ))}
            <div className="col-12 col-sm-12">
              <TextField
                readOnly
                value={guia["g_costo_subtotal"] || "0"}
                type="number"
                label="Subtotal"
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  )
                }}
              />
            </div>
            <div className="col-12 col-sm-12">
              <TextField
                readOnly
                value={guia["g_costo_iva"] || "0"}
                type="number"
                label="I.V.A."
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  )
                }}
              />
            </div>
            <div className="col-12 col-sm-12">
              <TextField
                readOnly
                value={guia["g_costo_retencion"] || "0"}
                type="number"
                label="Retencion."
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  )
                }}
              />
            </div>
            <div className="col-12 col-sm-12">
              <TextField
                readOnly
                value={guia["g_costo_total"] || "0"}
                type="number"
                label="Total"
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  )
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          {
            ready &&
            <EnvioFacturasDetalles {...this.props} showGuia={this.showGuia} id={id} currentEnvio={currentEnvio} />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(EnvioFacturas);